import { get, } from "@/api/axios";

// 列表
export const financeList = params => get('/web/region/finance/list', params);

// 统计
export const financeCount = params => get('/web/region/finance/count', params);